import {AfterViewInit, Component, EventEmitter, inject, Input, Output, PLATFORM_ID} from '@angular/core';
import {FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxMaskDirective, provideNgxMask} from 'ngx-mask';
import {isPlatformBrowser, NgIf} from '@angular/common';
import {AutofocusDirective} from '../../../../../common/directive/autofocus.directive';
import {AppFocusNextIdDirective} from '../../../../../common/directive/app-focus-next-id.directive';
import {take} from 'rxjs';
import {blank} from '../../../../../common/strings';

@Component({
  selector: 'app-phone',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    NgIf,
    AutofocusDirective,
    AppFocusNextIdDirective
  ],
  providers: [
    provideNgxMask(),
  ],
  templateUrl: './phone.component.html'
})
export class PhoneComponent implements AfterViewInit {

  @Input()
  formGroup: FormGroup;

  @Input()
  name: string;

  @Input()
  label: string

  @Input()
  placeholder: string

  @Input()
  showValidationErrors = true;

  @Input()
  tabIndex = 0

  @Input()
  autoFocus = false

  @Input()
  black = false

  @Input()
  appFocusNextId: string

  @Output()
  onChange = new EventEmitter<string>();

  platformId = inject(PLATFORM_ID);

  ngAfterViewInit() {

    if(isPlatformBrowser(this.platformId)) {
      this.formGroup.controls[this.name].valueChanges
        .pipe(take(1))
        .subscribe(value => {
          if(value) {
            const digits = value.replace(/[^\d]/g, blank);
            let normalized: string | null = null;
            if (digits.startsWith('0033')) {
              normalized = '0' + digits.slice(4);
            } else if (digits.startsWith('33') && digits.length === 11) {
              normalized = '0' + digits.slice(2);
            }
            if (normalized) {
              this.formGroup.controls[this.name].setValue(normalized, { emitEvent: false });
            }
          }
        });
    }
  }

}
